import React, { useState, useRef } from 'react';
import './FullPagePreview.css';
import ProTemplate from '../templates/ProTemplate';
import ModernTemplate from '../templates/ModernTemplate';
import MinimalTemplate from '../templates/MinimalTemplate';

const templates = { pro: ProTemplate, modern: ModernTemplate, minimal: MinimalTemplate };

const FullPagePreview = ({ data, template = 'pro', layout = 'single-column', sectionVisibility = {}, sectionOrder }) => {
  const TemplateComponent = templates[template] || templates.pro;
  const [zoom, setZoom] = useState(1);
  const pageRef = useRef(null);

  const zoomIn = () => setZoom(prev => Math.min(prev + 0.1, 2));
  const zoomOut = () => setZoom(prev => Math.max(prev - 0.1, 0.5));
  const resetZoom = () => setZoom(1);

  return (
    <div className="full-page-preview">
      <div className="preview-actions">
        <div className="zoom-controls">
          <button className="zoom-btn" onClick={zoomOut} title="Zoom Out">−</button>
          <span className="zoom-label">{Math.round(zoom * 100)}%</span>
          <button className="zoom-btn" onClick={zoomIn} title="Zoom In">+</button>
          <button className="zoom-reset-btn" onClick={resetZoom}>Reset</button>
        </div>
        <div className="action-buttons">
          <button className="print-button" onClick={() => window.print()}>
            Print Resume
          </button>
          <a href="/" className="back-button">Back to Editor</a>
        </div>
      </div>
      <div className="preview-page-container">
        <div
          ref={pageRef}
          className="preview-page"
          style={{
            transform: `scale(${zoom})`,
            transformOrigin: 'top center',
          }}
        >
          <TemplateComponent
            data={data}
            layout={layout}
            sectionVisibility={sectionVisibility}
            sectionOrder={sectionOrder}
            theme={data.theme}
          />
        </div>
      </div>
    </div>
  );
};

export default FullPagePreview;
